import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StockService } from '../../services/stock.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/shared/snackbar/snackbar.service';
import { Subject, takeUntil } from 'rxjs';
import { StoreStockLot } from '../../interfaces/stock.interface';

@Component({
  selector: 'app-stock-cost-form',
  templateUrl: './stock-cost-form.component.html',
  styleUrls: ['./stock-cost-form.component.scss']
})
export class StockCostFormComponent {
  @Input() stockData!: StoreStockLot;
  @Output() formSubmitted = new EventEmitter<boolean>();
  @Output() stepBackEmitter = new EventEmitter<void>();


  private readonly destroy$ = new Subject<void>();

  costForm: FormGroup;
  isLoading = false;


  constructor(
    private readonly fb: FormBuilder,
    private readonly stockService: StockService,
    private readonly translate: TranslateService,
    private readonly snackbarService: SnackbarService
  ) {
    this.costForm = this.createForm();
  }

  ngOnInit(): void {
    this.costForm.patchValue({
      stockId: this.stockData.lotId,
      cost: this.stockData.price
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private createForm(): FormGroup {
    return this.fb.group({
      stockId: ['', Validators.required],
      cost: [0]
    });
  }

  onSubmit(): void {

    if (this.costForm.valid && !this.isLoading) {

      try {
        let formValue = this.costForm.value;
        let cost: number = Number(formValue.cost);
        this.isLoading = true;

        // this.stockService.updateLotCost(this.stockData.lotId, cost)
        //   .pipe(takeUntil(this.destroy$))
        //   .subscribe({
        //     next: () => {
        //       this.isLoading = false;
        //       this.formSubmitted.emit(true);
        //     },
        //     error: (error) => {
        //       console.error('Error updating stock cost:', error);
        //       this.isLoading = false;
        //     }
        //   });
      }
      catch {
        console.error('Error casting number');
        this.isLoading = false;
      }



    } else {
      this.costForm.markAllAsTouched();
    }
  }



  goBack(): void {
    this.stepBackEmitter.emit();
  }
} 